import * as React from "react"
const sanityConfig = { projectId: "mo0idlaa", dataset: "production" }
export default sanityConfig
